import {
  NBS_API_GET_FORGOT_PASSWORD_REQUEST,
  NBS_API_GET_FORGOT_PASSWORD_SUCCESS,
  NBS_API_GET_FORGOT_PASSWORD_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        status: 'request'
      };
    case NBS_API_GET_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        status: 'success'
      };
    case NBS_API_GET_FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        status: 'fail'
      };
    default:
      return state;
  }
}
